import classNames from 'classnames';
import { useStaticQuery, graphql } from 'gatsby';
import React, { useContext } from 'react';

import AppContext from '../../context/AppContext';
import useResponsive from '../../hooks/useResponsive';
import Enquiries from '../Enquiries/Enquiries';
import Button, { themes as buttonThemes, sizes } from '../UI/Button/Button';
import Emphasise from '../UI/Emphasise/Emphasise';
import Ripple from '../UI/Ripple/Ripple';
import Section, { themes } from '../UI/Section/Section';
import * as styles from './FaqBanner.module.scss';

const FAQ_BANNER_QUERY = graphql`
  query FaqBannerQuery {
    wp {
      acfOptionsCommonBlocks {
        common {
          faqBanner {
            heading
            description
          }
        }
      }
    }
  }
`;

const FaqBanner = (props) => {
  const {
    wp: {
      acfOptionsCommonBlocks: {
        common: { faqBanner },
      },
    },
  } = useStaticQuery(FAQ_BANNER_QUERY);
  const app = useContext(AppContext);
  const { isLarge } = useResponsive();
  const classname = classNames(styles.container);

  function handleEnquiryClick(e) {
    app.dispatch({
      type: 'MODAL_SHOW',
      modal: {
        children: <Enquiries.Contact />,
      },
    });
  }

  return (
    <Section {...props} theme={themes.DEFAULT} id="locations">
      <div className={classname}>
        <Emphasise tag="h2" className={styles.heading}>
          {faqBanner.heading}
        </Emphasise>
        <div className={styles.body}>
          <p className={styles.description}>{faqBanner.description}</p>
          <Button
            theme={buttonThemes.PRIMARY}
            size={sizes.LARGE}
            onClick={handleEnquiryClick}
            isBlock={!isLarge}
          >
            Make an enquiry
          </Button>
        </div>

        <Ripple className={styles.ripple} />
      </div>
    </Section>
  );
};

export default FaqBanner;
